import { Box, Skeleton, Stack, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid2';

export default function OnboardingInsightsSkeleton() {
  const theme = useTheme();

  return (
    <Box>
      <Grid container spacing={2} mb={3}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 4 }}>
            <Box
              bgcolor='#fff'
              border='1px solid #ECECEC'
              borderLeft={`3px solid ${theme.palette.primary.main}`}
              borderRadius={2}
              p={2}
            >
              <Stack direction='row' justifyContent='space-between' mb={1}>
                <Skeleton width='70%' height={20} />
                <Skeleton variant='circular' width={32} height={32} />
              </Stack>
              <Skeleton width='40%' height={36} />
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} mb={3}>
        <Skeleton width={280} height={28} />
        <Skeleton width={300} height={20} sx={{ mt: 1, mb: 2 }} />
        <Skeleton variant='rectangular' height={300} sx={{ borderRadius: 1 }} />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2}>
            <Skeleton width={240} height={28} />
            <Skeleton width={320} height={20} sx={{ mt: 1, mb: 2 }} />
            <Skeleton variant='rectangular' height={420} sx={{ borderRadius: 1 }} />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2}>
            <Skeleton width={100} height={28} />
            <Skeleton width={280} height={20} sx={{ mt: 1, mb: 2 }} />
            <Skeleton variant='circular' width={240} height={240} sx={{ mx: 'auto' }} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
